import React, { Component } from 'react';
import 'lightgallery.js';
import 'lightgallery.js/dist/css/lightgallery.css';
import { Field, getFormValues, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { getExtraFeePrice } from "../../apiHelpers";
import { bookingFormInitialValues } from '../../store/reducers';
import CounterInput from '../CounterInput';
import Select from '../Select';
import BedConfig from '../../enums/BedConfig';
import RoomOfferGallery from '../Rooms/RoomOfferGallery';
import withLocalize from '../../withLocalize';
import CheckboxInput from "../CheckboxInput";

class RoomOffer extends Component {

	initLightGallery = ref => {
		this.lightGallery = ref;

		window.lightGallery(ref, {
			download: false
		});
	};

	componentWillUnmount() {
		// Unmount lightgallery.js
		if (this.lightGallery && this.lightGallery.getAttribute('lg-uid') && window.lgData) {
			window.lgData[this.lightGallery.getAttribute('lg-uid')].destroy();
		}
	}

	render() {
		const { formValues, roomOffer, roomIndex, noOfNights, extraFees, guestTypes, isBedTypeDisabled, translate: t, translatePropertyValue, translateSelectOptions } = this.props;

		if (!roomOffer) return null;

		return (
			<div className={`room-offer ${this.props.isLast ? 'room-offer--last' : ''}`}>

				{roomOffer.photos && roomOffer.photos.length > 0 &&
				<RoomOfferGallery roomOffer={roomOffer} />
				}

				<div className="room-offer__text-container">
					<h2 className="room-offer__room-name">{roomOffer.name}</h2>

					<br />

					{Object.values(guestTypes).map((guestType, index) => (
						<Field
							component={CounterInput}
							name={`rooms[${roomOffer.id}][${roomIndex}][guestTypes][${guestType.id}]`}
							className="large-input--inline"
							label={guestType.name}
							max={roomOffer.beds+roomOffer.extrabeds}
							key={`guestType-${guestType.id}`}
						/>
					))}

					{!isBedTypeDisabled && roomOffer.bedConfig === BedConfig.VARIABLE &&
					<Field
						component={Select}
						name={`rooms[${roomOffer.id}][${roomIndex}]`}
						className="large-input--counter"
						label={t('SelectedRooms.RoomOffer.bedConfig')}
						options={translateSelectOptions(BedConfig.getOptions())}
						normalize={(value, previousValue) => ({
							...previousValue,
							bedConfig: parseInt(value, 10),
						})}
						format={value => value.bedConfig}
					/>
					}

					{Object.values(extraFees).map(extraFee => (
						<Field
							component={CheckboxInput}
							name={`rooms[${roomOffer.id}][${roomIndex}][extraFees][${extraFee.id}]`}
							id={`room-${roomOffer.id}-${roomIndex}-extraFee-${extraFee.id}`}
							label={`${translatePropertyValue(extraFee.name)} (${getExtraFeePrice(extraFee, noOfNights,null, formValues.currency, false) < 0 ? '-' : '+'} ${getExtraFeePrice(extraFee, noOfNights,null, formValues.currency, true, true)})`}
							key={`extraFee-${extraFee.id}`}
						/>
					))}
				</div>
			</div>
		);
	}
}

export default compose(
	connect(state => ({
		formValues: getFormValues('bookingForm')(state),
		noOfNights: state.app.noOfNights,
		extraFees: state.app.extraFees,
		guestTypes: state.app.guestTypes,
		isBedTypeDisabled: state.app.isBedTypeDisabled,
	})),
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	withLocalize,
)(RoomOffer);



// WEBPACK FOOTER //
// ./src/components/SelectedRooms/RoomOffer.jsx